import React from 'react';
import './Toggle.css';
import styled, { DefaultTheme } from 'styled-components';

interface Props {
    theme?: DefaultTheme;
    checked: boolean;
    onToggle: (event: any) => void;
}

type ToggleButtonType = {
    active: boolean;
    theme?: DefaultTheme;
};

const ToggleContainer = styled.div`
    position: relative;
    display: flex;
    cursor: pointer;
    width: 200px;
    height: 36px;
    background-color: aliceblue;
    border-radius: 25px;
    font-size: 14px;
`;

const SwitchButton = styled.button`
    position: relative;
    background-color: transparent;
    cursor: pointer;
    width: 50%;
    height: 36px;
    border: 0;
    opacity: 0.4;
 
    z-index: 1;
    opacity: ${(props: ToggleButtonType) => (props.active ? 1 : 0.4)};

    :focus {
        outline: 0;
    }
    
    /* transform: ${(props: ToggleButtonType) => (props.active ? 'translateX(150px)' : '')}; */
`;

const LeftSwitch = styled(SwitchButton)``;

const RightSwitch = styled(SwitchButton)`
    margin-left: 10px;
`;

const Slider = styled.span`
    position: absolute;
    width: 100px;
    height: 36px;

    left: 0px;
    background-color: white;
    font-size: 14px;
    border-radius: 21px;
    transition: all 0.4s;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    transform: ${(props: ToggleButtonType) => (props.active ? 'translateX(100px)' : '')};
`;

export const Toggle: React.FC<Props> = ({ checked, onToggle }: Props) => {
    return (
        <ToggleContainer>
            <LeftSwitch
                onClick={(evt) => {
                    checked && onToggle(evt);
                }}
                active={!checked}
            >
                Simple
            </LeftSwitch>
            <RightSwitch
                onClick={(evt) => {
                    !checked && onToggle(evt);
                }}
                active={checked}
            >
                Advanced
            </RightSwitch>
            <Slider active={checked} />
        </ToggleContainer>
    );
};

export default Toggle;
